export const symbolAppId = Symbol("appId");
export const symbolMenuI18nNamespace = Symbol("menuI18nNamespace");
export const symbolOverrideApp = Symbol("overrideApp");
//# sourceMappingURL=constants.js.map